/**
 * @fileoverview Main entry point for the RAG chatbot system
 * @module chatbot
 *
 * This module provides a comprehensive chatbot solution with RAG capabilities,
 * including client components, admin tools, and core functionality.
 */

// Core exports (API, contexts, services)
export * from "./core";

// Client components
export * from "./client";

// Admin components
export * from "./admin";

// Type definitions
export * from "./types";

// Utilities
export * from "./utils";
